"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BtnIssueInvoice = class BtnIssueInvoice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    confirmMessage;
    onConfirm_message(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("confirmMessage");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    target;
    onTarget(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("target");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    bntText: "Számla kiállítása",
                    btnTooltip: "A számla véglegesítése és kiállítása.",
                },
                ux: null,
            },
        };
    }
    async act_7315092382398562_emit_7110_getActionArgs($event) {
        return {
            event: "success",
        };
    }
    async act_7315092382398562_request_7108_getActionArgs($event) {
        return {
            operation: "update_invoice_status",
            data: { id: this.invoice.id, status: 'completed', etag: this.invoice.etag },
        };
    }
    async act_7315092382398562_request_7108_getConfirm($event) {
        return {
            header: "Számla kiállítása",
            message: this.confirmMessage,
            btnOk: "Számla kiállítása",
            btnCancel: "Mégsem",
            severity: "warning",
        };
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_7110 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_7110_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_success_7109 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_7110,
            event: "success",
            displayName: "emit",
        });
        const act_7315092382398562_request_7108 = new core_1.actions.RequestAction({
            actionArgs: this.act_7315092382398562_request_7108_getActionArgs,
            confirm: this.act_7315092382398562_request_7108_getConfirm,
            displayName: "submit",
            events: [evh_7315092382398562_success_7109],
        });
        const evh_7315092382398562_clickPreventStop_7107 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_request_7108,
            event: "click.prevent.stop",
            displayName: "submit",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_7107],
        });
        return {
            act_7315092382398562_emit_7110,
            evh_7315092382398562_success_7109,
            act_7315092382398562_request_7108,
            evh_7315092382398562_clickPreventStop_7107,
            evh_7315092382398562_clickPreventStop,
            submit: act_7315092382398562_request_7108,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], BtnIssueInvoice.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnIssueInvoice.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "Kérem erősítse meg a számla kiállítását! A kiállított számla utólag már nem módosítható.\n",
    }),
    __metadata("design:type", String)
], BtnIssueInvoice.prototype, "confirmMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('confirmMessage'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnIssueInvoice.prototype, "onConfirm_message", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BtnIssueInvoice.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnIssueInvoice.prototype, "onSize", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "self",
    }),
    __metadata("design:type", String)
], BtnIssueInvoice.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('target'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnIssueInvoice.prototype, "onTarget", null);
BtnIssueInvoice = __decorate([
    (0, vue_property_decorator_1.Component)()
], BtnIssueInvoice);
exports.default = BtnIssueInvoice;
vue_property_decorator_1.Vue.component("BtnIssueInvoice", BtnIssueInvoice);
